import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import "./Header.scss";
import {useEffect, useState} from "react";
import {RouteHelper} from "../../route/RouteHelper";
import LogOut from "../Sidebar/logout/LogOut";
import {css} from "@emotion/css";
import SidebarMobile from "../Sidebar/SidebarMobile";
import {Link} from "react-router-dom";
import {ProfileService} from "../../pages/profile/ProfileService";
import {Skeleton} from "@mui/material";
import {RaikoDivider} from "@moeindal/base-raiko-panel-components";

import defaultAvatar from "../../assets/images/avatar-default.jpg";
import RaikoUploaderHeaderItem
    from "../../raikoComponents/raikoUploader/raikoUploaderHeaderItem/RaikoUploaderHeaderItem";

const Header = () => {

    const [openDialog, setOpenDialog] = useState(false)
    const handleClickOpen = () => {
        setOpenDialog(true)
        setAnchorEl(null);
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClickClose = () => {
        setOpenDialog(false)
    }

    const [adminName, setAdminName] = useState("")
    const [adminAvatar, setAdminAvatar] = useState("");
    const [adminUsername, setAdminUsername] = useState("");
    const [adminAvatarLoading, setAdminAvatarLoading] = useState(false);


    const service = new ProfileService()
    const [adminNameLoadingState, setAdminNameLoadingState] = useState(false);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            setAdminNameLoadingState(true)
            service.getProfileDetail().then(response => {
                setAdminName(`${response.firstName} ${response.lastName}`)
                setAdminUsername(response.username)
                setAdminNameLoadingState(false)
            }).catch(reason => {
                setAdminNameLoadingState(false)
            })

            // setAdminAvatarLoading(true)

            /*service.getAvatarAdmin()
                .then(response => {
                    setAdminAvatar(response.downloadUrl.replaceAll('http:', 'https:'))
                }).catch(reason => {

            }).finally(_ => {
                setAdminAvatarLoading(false)
            })*/
        }
    }, [])



    return (
        <>
            {
                <LogOut
                    openDialog={openDialog}
                    handleClickClose={handleClickClose}
                />
            }



            <header>
                <section className="headerContainer">

                    <div>
                        <div
                            className={"headerUserInfoContainer"}
                            id="btn-dropdown"
                            onClick={handleClick}
                        >
                            {
                                adminAvatarLoading ?
                                    <Avatar
                                        className={"headerUserAvatar"}
                                        id="avatar"
                                        alt="avatar"
                                        src={""}
                                    />
                                    :
                                    <Avatar
                                        className={"headerUserAvatar"}
                                        id="avatar"
                                        alt={adminUsername}
                                        src={adminAvatar && adminAvatar.length > 0 ? adminAvatar : defaultAvatar}
                                    />
                            }


                            <div className={"usernameContainer"}>
                                <span className={"usernameContainerTitle"}>مدیریت</span>
                                {adminNameLoadingState ?
                                    <div className={"usernameShimmerContainer"}/> :
                                    <span className={"usernameText"}>{adminName}</span>
                                }
                            </div>
                            <div className="dropdown-item-icon ic-arrow-left"/>
                        </div>
                        <Menu
                            id="demo-customized-menu"
                            MenuListProps={{
                                'aria-labelledby': 'demo-customized-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                        >

                            <Link to={RouteHelper.Profile.globalUrl}>
                                <MenuItem onClick={handleClose} disableRipple>
                                    <section className="dropdown-item-icon account-icon"/>
                                    حساب کاربری
                                </MenuItem>
                            </Link>
                            <RaikoDivider/>
                            <MenuItem onClick={handleClickOpen} disableRipple>
                                <section className="dropdown-item-icon logOut-icon"/>
                                خروج
                            </MenuItem>
                        </Menu>
                    </div>
                    <RaikoUploaderHeaderItem/>
                    <div className={css`flex-grow: 1`}>
                        <SidebarMobile/>
                    </div>
                </section>
            </header>
        </>

    )
}
export default Header;
